// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3gRn-","tabsBox":"styles_tabsBox__2r7SK","createButton":"styles_createButton__3Nsz4"};